// The amount a completed donation is reported to analytics with. Prefers what
// the page itself charged (fee included when the donor covered it), which is the
// same figure the backend files in Gramsci, over the {sum} IsraelGives hands back
// in the successurl — that placeholder has arrived empty, and Number('') is 0,
// which GA4 shows as ₪0 revenue and zero transactions.
export function resolvePurchaseValue(total, sum) {
  const t = Number(total);
  if (Number.isFinite(t) && t > 0) return t;
  const s = Number(sum);
  return Number.isFinite(s) && s > 0 ? s : 0;
}

// GA4 `purchase`, pushed the way the GTM container reads it. Its tags take
// value from the Data Layer Variable `ecommerce.value` (`dlv - value`), so the
// amount has to live in an `ecommerce` object: a bare gtag('event', 'purchase',
// { value }) reaches GTM with value undefined — GA4, both Meta Pixel tags, the X
// pixel and the server-side tags all lost the amount that way.
//
// Fired once per transaction id per browser session, so a redelivered message or
// a page reload can't count the same donation twice.
export function trackPurchase({ transactionId, value, currency }) {
  const id = transactionId || '';
  const key = `purchase-tracked:${id}`;
  if (id) {
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, '1');
    } catch {
      /* storage blocked — fall through and send; the page-level guard still applies */
    }
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object
  window.dataLayer.push({
    event: 'purchase',
    transaction_id: id,
    value,
    currency,
    ecommerce: { transaction_id: id, value, currency },
  });
}
